jQuery(document).ready(function($) {
  	$('#menu-toggle').on('click touchstart', function(event){
		$('html, body').toggleClass('main-menu-active');       
        $(this).toggleClass('active');
        $('nav.menu--main > ul > li').removeClass('menu-open');
        event.stopImmediatePropagation();
        event.preventDefault();
    });

    $('#block-hoofdnavigatie > ul.menu > li.menu-item--expanded > a').on('click touchstart', function(event){
        event.stopImmediatePropagation();
        event.preventDefault();
        $('nav.menu--main > ul.menu > li.menu-item--expanded').not( $(this).parent('li') ).removeClass('menu-open');
        $(this).closest('li').toggleClass('menu-open');
        $('body').toggleClass('submenu-active');
    });

    $('#block-hoofdnavigatie ul.menu li .submenu-wrapper .menu-back-link').on('click touchstart', function(event){      
        $(this).closest('li.menu-item--expanded').removeClass('menu-open');
        $('body').removeClass('submenu-active');
        event.preventDefault();
        event.stopPropagation();
    });

    $('body').on('click touchstart', function(event){
        if (!$(event.target).closest('#block-menuwrapper').length) {
            $('.menu--main').removeClass('menu-open');
            $('body').removeClass('main-menu-active');
            $('ul.menu li').removeClass('active');
            $('#menu-toggle').removeClass('active');
            // $('#block-taalkeuze .languages .other, #block-taalkeuze .languages > .is-active').removeClass('menu-open');
            
            $('nav#block-hoofdnavigatie > ul.menu > li.menu-item--expanded').removeClass('menu-open');
            $('header > nav').removeClass('open-menu');
        }
    });


    $(document).keydown(function(e){
        if (e.keyCode == 27) {
            $('.menu--main').removeClass('menu-open');
            $('body').removeClass('main-menu-active');
            $('ul.menu li').removeClass('active');
            $('#menu-toggle').removeClass('active');
            
            $('nav#block-hoofdnavigatie > ul.menu > li.menu-item--expanded').removeClass('menu-open');
            $('header > nav').removeClass('open-menu');
        }
    });
});